const separator = {
    comma: ',',
    pipe: '|',
    tab: '\t',
    semicolon: ';'
};

export default separator;
